import { createSelectionListViewContainer } from 'factories/SelectionListView'
import splitTypes from 'options/cycleCounts/cycleCountSplitTypes'
import { wrapItems } from 'helpers/utils'
import { t } from 'helpers/i18n'
import Component from 'components/CycleCounts/Split/SelectType'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      wrapItems(
        Object.entries(splitTypes)
          .filter(([key, value]) => key !== 'All')
          .map(([key, value]) => ({ id: key, displayName: t(value) }))
      ),
  }),
})(Component)
